import { IsNotEmpty, IsString } from 'class-validator';

export class GetScheduleFiltersDto {
  @IsString()
  @IsNotEmpty()
  scheduleId: string;
}
